import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-custom-development',
  imports: [RouterLink],
  templateUrl: './custom-development.html',
  styleUrl: '../service-pages.scss',
})
export class CustomDevelopment {}
